export default "__VITE_ASSET__abe150b0__"